import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    CartesianGrid
} from 'recharts';


const BarChartComponent = ({ stats }) => {

    const totalSummary = stats.reduce(
        (acc, item) => {
            acc.temples += item.temples;
            acc.monastery += item.monastery;
            acc.pattasima += item.pattasima;
            acc.wisung += item.wisung;
            acc.raj += item.raj;
            acc.royal += item.royal;
            acc.totalAll += item.totalAll;
            return acc;
        },
        {
            temples: 0,
            monastery: 0,
            pattasima: 0,
            wisung: 0,
            raj: 0,
            royal: 0,
            totalAll: 0
        }
    );

    //console.log('totalSummary', stats);

    const data = [
        { name: 'วัด', value: totalSummary.temples },
        { name: 'พระอารามหลวง', value: totalSummary.royal },
        { name: 'วัดราษฎ์', value: totalSummary.raj },
        { name: 'วิสุงคามสีมา', value: totalSummary.wisung },
        { name: 'พัทธสีมา', value: totalSummary.pattasima },
        { name: 'ที่พักสงฆ์', value: totalSummary.monastery },
    ];

    return (
        <div style={{ width: '100%', height: 400 }}>
            <h3 style={{ textAlign: 'center' }}>
                สถิติวัดแต่ละประเภท (รวมทุกจังหวัด)
            </h3>

            {data && (
                <>
                    <ResponsiveContainer>
                        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="value" fill="#ad7c00" name="จำนวน" />
                        </BarChart>
                    </ResponsiveContainer>
                </>
            )}

        </div>
    );
};

export default BarChartComponent;
